import React from 'react';
import { Box } from '@mui/material';
import VeraPromptContextGuide from '../VeraPromptContextGuide';
import { getVeraPromptContextGuide } from '../veraPromptContextGuides';
import { StyledButton } from '../../styles/StyledButtons';
import StyledFieldDescription from '../../styles/StyledFieldDescription';
import { StyledLabel } from '../../styles/styles';
import {
  MONOSPACE_TEXTAREA_STYLE,
  PRODUCTION_REFERENCE_SX,
} from '../VeraAdminChatAssistPromptSandbox/adminAssistPromptStyles';

interface InvestorGroundingPromptTabProps {
  groundingText: string;
  groundingProductionText: string;
  globalGuideOptions: { googleSearchEnabled: boolean; googleSearchLinksEnabled: boolean };
  onGroundingChange: (value: string) => void;
  onResetToProduction: () => void;
}

export default function InvestorGroundingPromptTab({
  groundingText,
  groundingProductionText,
  globalGuideOptions,
  onGroundingChange,
  onResetToProduction,
}: InvestorGroundingPromptTabProps) {
  return (
    <>
      <VeraPromptContextGuide
        markdown={getVeraPromptContextGuide('global_grounding', globalGuideOptions)}
      />
      <StyledFieldDescription stacked sx={{ mb: 2 }}>
        Rules for when investor global Vera chat may use Google Search. Controlled by global
        configuration; this sandbox can enable search for testing without changing production.
        Stricter than admin assist. Coded file:{' '}
        <code>vera-global-chat-google-search-grounding-instruction.md</code>
      </StyledFieldDescription>

      <Box sx={{ mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
          <StyledLabel stacked>Google Search Grounding Prompt</StyledLabel>
          <StyledButton
            size="small"
            variant="outlined"
            onClick={onResetToProduction}
            disabled={groundingText.trim() === groundingProductionText.trim()}
          >
            Reset to coded version
          </StyledButton>
        </Box>
        <textarea
          value={groundingText}
          onChange={(event) => onGroundingChange(event.target.value)}
          rows={14}
          style={{ ...MONOSPACE_TEXTAREA_STYLE, marginTop: 8 }}
        />
      </Box>

      {groundingProductionText && (
        <Box sx={{ mb: 3 }}>
          <StyledLabel stacked>Current coded version (read-only reference)</StyledLabel>
          <Box
            component="pre"
            sx={{ ...PRODUCTION_REFERENCE_SX, maxHeight: 180, overflowY: 'auto' }}
          >
            {groundingProductionText}
          </Box>
        </Box>
      )}
    </>
  );
}
